import React from "react";
import moment from "moment";
import { RaisedButton, FlatButton, FontIcon } from "material-ui";
import { formatPrice, fillMissingDaysNew } from "../util";
import WorkingIndicator from "./partials/working-indicator.jsx";

import Chart from "./partials/charts/chart.jsx";
import InjectedSelect from "./partials/injected-select.jsx";
import DatePicker from "./partials/datepicker.jsx";
import QuantityEditor from "./partials/quantity-editor.jsx";
import Label from "./partials/label.jsx";

import connectToStores from "alt-utils/lib/connectToStores";
import EventBucketActions from "../actions/EventBucketActions";
import EventBucketStore from "../stores/EventBucketStore";
import AnalyticsStore from "../stores/AnalyticsStore";
import AnalyticsActions from "../actions/AnalyticsActions";
import UserStore from "../stores/UserStore";

const LOCALSTORAGE_KEY = "eventive-CrossEventBucketReports";
const MS_IN_DAY = 1000 * 60 * 60 * 24;

class CrossEventBucketReports extends React.Component {
  constructor(props) {
    super(props);
    this.state = {
      startDates: {},
      selectedBuckets: [],
      endAfter: 10
    };

    this.setBuckets = this.setBuckets.bind(this);
  }

  static getStores() {
    return [EventBucketStore, AnalyticsStore];
  }

  static getPropsFromStores() {
    return {
      getEventBuckets: EventBucketStore.getEventBuckets,
      getEventBucketById: EventBucketStore.getEventBucketById,
      getEventBucketSalesById: AnalyticsStore.getEventBucketSalesById
    };
  }

  static get contextTypes() {
    return {
      router: React.PropTypes.object
    };
  }

  getStyles() {
    return {};
  }

  setBuckets(buckets) {
    let { startDates } = this.state;

    buckets
      .filter(b => this.state.selectedBuckets.indexOf(b) === -1)
      .map(id => {
        let bucket = EventBucketStore.getEventBucketById(id),
          oldStart = bucket && bucket.start_date;
        startDates[id] =
          startDates[id] ||
          (oldStart && oldStart.slice(0, "YYYY-MM-DD".length));
        AnalyticsActions.fetchEventBucketSales.defer(id);
      });

    this.setState({
      selectedBuckets: buckets,
      startDates
    });

    try {
      if (window.localStorage) {
        window.localStorage[
          LOCALSTORAGE_KEY + UserStore.getUserId()
        ] = JSON.stringify(buckets);
      }
    } catch (e) {}
  }

  componentDidMount() {
    this.componentWillReceiveProps(this.props);
  }

  componentWillReceiveProps(newProps) {
    if (
      this.state.selectedBuckets.length === 0 &&
      newProps.getEventBuckets().length
    ) {
      try {
        if (
          window.localStorage &&
          window.localStorage[LOCALSTORAGE_KEY + UserStore.getUserId()]
        ) {
          this.setBuckets(
            JSON.parse(
              window.localStorage[LOCALSTORAGE_KEY + UserStore.getUserId()]
            )
          );
        }
      } catch (e) {}
    }
  }

  setStartDate(id, d) {
    let { startDates } = this.state;

    if (d) {
      EventBucketActions.edit(id, {
        start_date: d
      });
    }

    startDates[id] = d;
    this.setState({ startDates });
  }

  render() {
    let styles = this.getStyles(),
      { getEventBucketById, getEventBucketSalesById } = this.props;

    return (
      <div>
        <h1>Cross-event-bucket comparison</h1>
        <InjectedSelect
          value={this.state.selectedBuckets}
          types={["event_buckets"]}
          multi={true}
          label="Event buckets to compare"
          labelFormatter={b => b.name}
          onChange={this.setBuckets}
        />
        <div>
          {this.state.selectedBuckets.map(id => {
            let b = getEventBucketById(id);
            return (
              <DatePicker
                style={{
                  width: 256,
                  display: "inline-block",
                  marginRight: "1em"
                }}
                value={this.state.startDates[id]}
                label={`${b.name} start date`}
                onChange={v => this.setStartDate(b.id, v)}
              />
            );
          })}
          {this.state.selectedBuckets.length ? (
            <div style={{ display: "inline-block" }}>
              <Label>Days after start date to end graph</Label>
              <QuantityEditor
                style={{ marginTop: -14, marginLeft: -17 }}
                quantity={this.state.endAfter}
                updateQuantity={q => this.setState({ endAfter: q })}
              />
            </div>
          ) : null}
        </div>
        <div>
          {this.state.selectedBuckets.length > 1 &&
          this.state.selectedBuckets.every(
            id => !!this.state.startDates[id]
          ) ? (
            (() => {
              let sales = this.state.selectedBuckets.map(id =>
                getEventBucketSalesById(id)
              );
              if (!sales.every(b => !!b)) {
                return <WorkingIndicator />;
              }

              const data = {};

              sales.forEach((s, i) => {
                let id = this.state.selectedBuckets[i],
                  startDate = moment(this.state.startDates[id], "YYYY-MM-DD");

                s.forEach(next => {
                  let diff = -startDate.diff(
                    new Date(
                      next.date.year,
                      next.date.month - 1,
                      next.date.day
                    ),
                    "days"
                  );
                  if (diff > this.state.endAfter) {
                    return;
                  }
                  if (!data[diff]) {
                    data[diff] = {};
                  }
                  data[diff][id] = next.running_net / 100;
                });
              });

              let offsets = Object.keys(data).sort((a, b) => a - b),
                firstDate = new Date(offsets[0] * -1 * MS_IN_DAY);

              let names = this.state.selectedBuckets.map(
                id => getEventBucketById(id).name
              );
              let rows = [];
              offsets.forEach((k, i) => {
                // if (i === 53) { debugger; }
                let value = this.state.selectedBuckets.map(
                  (id, bucketIndex) => ({
                    type: names[bucketIndex],
                    result:
                      data[k][id] ||
                      (i > 1 && rows[i - 1].value[bucketIndex].result) ||
                      0
                  })
                );
                rows.push({
                  timeframe: { end: new Date((k - offsets[0]) * MS_IN_DAY) }, // start at date 0
                  value: value
                });
              });

              let filledRows = fillMissingDaysNew(
                rows,
                "timeframe.end",
                {},
                { cloneAll: true }
              );
              filledRows = filledRows.map(r => {
                r.timeframe.end = r.timeframe.end.toISOString();
                return r;
              });

              let chartOptions = {
                axis: {
                  y: {
                    tick: {
                      format: p => formatPrice(p * 100, /* short */ true)
                    }
                  },
                  x: {
                    tick: {
                      format: d => {
                        let o = (d - firstDate) / MS_IN_DAY;
                        return (o > 0 ? "+" : "") + o.toFixed(0);
                      }
                    }
                  }
                },
                point: { show: false },
                tooltip: {
                  format: {
                    value: (value, ratio, id, index) => {
                      let bucketIndex = filledRows[index].value.findIndex(
                          v => v.type === id
                        ),
                        bucketId = this.state.selectedBuckets[bucketIndex],
                        date = moment(
                          this.state.startDates[bucketId],
                          "YYYY-MM-DD"
                        ).add(
                          (new Date(filledRows[index].timeframe.end) -
                            firstDate) /
                            MS_IN_DAY,
                          "days"
                        );
                      return `${formatPrice(value * 100)} (${date.format(
                        "M/D/YY"
                      )})`;
                    },
                    title: d => {
                      let o = (d - firstDate) / MS_IN_DAY;
                      return `${Math.abs(o).toFixed(0)} day${
                        Math.abs(o) === 1 ? "" : "s"
                      } ${o > 0 ? "after" : "before"} the start date`;
                    }
                  }
                }
              };

              return (
                <Chart
                  title="Total net sales"
                  type="area"
                  indexBy="timeframe.end"
                  dateFormat="%b %e"
                  chartOptions={chartOptions}
                  data={{ result: filledRows }}
                  height={500}
                />
              );
            })()
          ) : (
            <Chart
              title=""
              placeholder={`Select two or more event buckets & start dates to begin.`}
              height={200}
            />
          )}
        </div>
      </div>
    );
  }
}

export default connectToStores(CrossEventBucketReports);



// WEBPACK FOOTER //
// ./src/app/components/cross-event-bucket-reports.jsx